/**
 * Include your custom JavaScript here.
 */

const Floral = window['Floral'] || {};
const $ = jQuery.noConflict();

// Global variable to hold the URL the user wants to visit after postcode/date selection
window.floralPendingUrl = null;

Floral.requests = [];

Floral.addRequest = function (request) {
  Floral.requests.push(request);
  if (Floral.requests.length === 1) {
    Floral.run();
  }
};

Floral.run = function () {
  const originalCallback = Floral.requests[0].complete;
  Floral.requests[0].complete = function () {
    if (typeof originalCallback === 'function') {
      originalCallback();
    }
    Floral.requests.shift();
    if (Floral.requests.length > 0) {
      Floral.run();
    }
  };
  $.ajax(Floral.requests[0]);
};

Floral.init = function () {
  const chosenPostcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
  const $postcodeSelectorForm = $('#postcode-selector-form');

  /***********************************************
   * SITE WIDE
   */
  Floral.utils.initAutoComplete();
  Floral.utils.updateAllTextRelatedToDelivery(true);
  Floral.utils.updateAllTextRelatedToDate();
  void Floral.utils.initDeliveryLogics();

  /**
   * Listen to postcode change event
   */
  $(document).on('postcode_updated.floral', function () {
    Floral.utils.initDeliveryVariant();
    Floral.utils.updateAllTextRelatedToDelivery();
    Floral.utils.disableVariantsWhenRegionOutOfStock();
    void Floral.utils.initDeliveryLogics();
    void Floral.cart.updateCartAttrs();
    void Floral.utils.initDatePickers();
  });

  /**
   * Redirect baton after date selection.
   * IMPORTANT: Uses setTimeout so the datepicker's own handler can run first (close modal, set sessionStorage, etc).
   */
  $(document)
    .off('date_updated.floralRedirect')
    .on('date_updated.floralRedirect', function () {
      if (!window.floralPendingUrl) return;

      const url = window.floralPendingUrl;
      window.floralPendingUrl = null;

      setTimeout(function () {
        window.location.href = url;
      }, 150);
    });

  /**
   * Also run collection DOM-filtering logic on date change (non-navigational; safe).
   */
  $(document)
    .off('date_updated.floralFilter')
    .on('date_updated.floralFilter', function () {
      try { Floral.collection.filterProductsByDate(); } catch (e) {}
    });

  /**
   * Listen to side cart updated event. This is to re-init date pickers
   */
  $(document).on('cart:drawer:updated', function () {
    void Floral.utils.initDatePickers();
    Floral.utils.initDeliveryVariant();
  });

  /**
   * Listen to quick buy popup event
   */
  $(document).on('openable-element:open', function (event) {
    switch (event.target.nodeName) {
      case 'QUICK-BUY-POPOVER':
      case 'QUICK-BUY-DRAWER':
        setTimeout(function () {
          Floral.utils.initAutoComplete();
          Floral.utils.initDeliveryVariant();
          Floral.utils.updateAllTextRelatedToDelivery(true);
        }, 300)
        break;
      case 'CART-DRAWER':
        break;
    }
  });

  /**
   * Postcode form submission
   */
  $(document).on('submit', '#postcode-selector-form', function (e) {
    Floral.utils.handlePostcodeSubmission(e);
  });

  /**
   * Prefill suburbs with suburbs pills click
   */
  $(document).on('click', '#postcode-pick-sample a', function (e) {
    e.preventDefault();
    Floral.utils.initSampleRegion($(this).data('region'));
  });

  /**
   * Handle postcode modal links
   */
  $(document).on('click', '[data-delivery-open-postcode]', function (e) {
    e.preventDefault();
    Floral.utils.openPostcodeModal();
  });

  /**
   * Handle click for opening datepicker (only on product pages)
   */
  $(document).on('click', '[data-delivery-open-datepicker]', function (e) {
    if ($('body').hasClass('template-product')) {
      e.preventDefault();
      document.getElementById('datepicker-modal').open = true;
    }
  });

  /**
   * UPDATED: Handle internal clicks to collection buttons
   * - If postcode/date missing: open modal flow and store FINAL destination in window.floralPendingUrl
   * - If both exist: compute FINAL destination (tag path applied/removed) and navigate directly (no double-load redirect)
   */
  $(document).on('click', 'a.button[href*="/collections/"]', function (e) {
    const href = $(this).attr('href');
    if (!href) return;

    const currentPostcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
    const currentDate = sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);

    // Compute final destination based on selected date (adds/removes /valentines tag segment)
    const finalHref = Floral.utils.getCollectionHrefForSelectedDate(href);

    // If either is missing, intercept the click and open required modal(s)
    if (!currentPostcode || !currentDate) {
      e.preventDefault();

      // Save FINAL destination as the baton (so once date is chosen, we go to the right URL)
      window.floralPendingUrl = finalHref;
      $postcodeSelectorForm.data('target', finalHref); // legacy backup

      if (!currentPostcode) {
        Floral.utils.openPostcodeModal();
      } else {
        document.getElementById('datepicker-modal').open = true;
      }
      return;
    }

    // Both exist; if the final URL differs, prevent default and navigate directly
    if (finalHref !== href) {
      e.preventDefault();
      window.location.href = finalHref;
    }
  });

  /***********************************************
   * SPECIFIC TEMPLATES
   */
  Floral.product.init();
  Floral.collection.init();
  Floral.cart.init();
};

Floral.cart = {
  init: function () {
    if ($('body').hasClass('template-cart')) {
      void Floral.utils.initDatePickers();
      Floral.utils.initDeliveryVariant();
    }
  },
  changeCartLineItemsAtts: function (dateAU, timeSlot = null) {
    const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const keysProperty = {
      deliveryDayOfWeek: '_delivery__day_of_week',
      deliveryTimeSlotPicked: '_delivery__time_slot_picked',
      orderTimeString: '_order__time_string',
    };
    const keysOrderTimes = {
      appSameDayBeforeMidDay: 'same_day_before_mid_day',
      appSameDayBefore4pm: 'same_day_before4pm',
      appSameDayAfter4pm: 'same_day_after4pm',
    };

    // Default properties
    let properties = {
      [keysProperty.deliveryTimeSlotPicked]: timeSlot ? 'yes' : null,
    };

    if (dateAU) {
      const chosenStateCurrentDayTime = Floral.utils.getChosenStateCurrentDateTime();
      const currentHours = chosenStateCurrentDayTime.hour;
      const [day, month, year] = dateAU.split('/');
      const dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      properties = Object.assign(properties, {
        [keysProperty.deliveryDayOfWeek]: daysOfWeek[dateObj.getDay()],
        [keysProperty.orderTimeString]: '',
      });
      if (
        dateObj.getDate() === chosenStateCurrentDayTime.day &&
        (dateObj.getMonth() + 1) === chosenStateCurrentDayTime.month &&
        dateObj.getFullYear() === chosenStateCurrentDayTime.year
      ) {
        properties[keysProperty.orderTimeString] = (
          currentHours < 12 ?
            keysOrderTimes.appSameDayBeforeMidDay :
            (
              currentHours < window.themeVariables.constants.appSameDayCutoffHour ?
                keysOrderTimes.appSameDayBefore4pm :
                keysOrderTimes.appSameDayAfter4pm
            )
        );
      }
    }

    // Retrieve cart data first
    $.ajax({
      url: `${window.themeVariables.routes.cartUrl}.js`,
      type: 'GET',
      dataType: 'json',
      success: function (currentCart) {
        if (currentCart['item_count'] > 0) {
          currentCart['items'].forEach((currentCartItem, currentCartIndex) => {
            Floral.addRequest({
              url: `${window.themeVariables.routes.cartUrl}/change.js`,
              type: 'POST',
              dataType: 'json',
              data: {
                id: currentCartItem['key'],
                properties: Object.assign(
                  (currentCartItem.properties !== null ? currentCartItem.properties : {}),
                  properties
                )
              },
              success: function (updatedCart) {
                const $cartItem = $(`a[data-line-id="${currentCartItem['key']}"]`);
                $cartItem.attr('data-line-id', updatedCart['items'][currentCartIndex]['key']);
                $cartItem.each(function () {
                  const cartItemLinkHref = $(this).attr('href');
                  const cartItemLinkHrefParts = cartItemLinkHref.split('?');
                  const cartItemLinkHrefParams = new URLSearchParams(cartItemLinkHrefParts[1]);
                  cartItemLinkHrefParams.set('id', updatedCart['items'][currentCartIndex]['key']);
                  $(this).attr('href', `${cartItemLinkHrefParts[0]}?${cartItemLinkHrefParams.toString()}`);
                });
              }
            });
          });
        }
      }
    });
  },
  updateCartAttrs: async function () {
    const postcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
    if (postcode) {
      await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: JSON.stringify({ attributes: { _delivery__postcode: postcode } }),
        credentials: "same-origin",
        method: "POST",
        headers: { "Content-Type": "application/json" }
      });
    }
  },
  setDeliveryPostcode: function () {
    const isPostcodeAutoSet = !!Floral.cookie.get(window.themeVariables.constants.cookieNamePostcodeAutoSet);
    const chosenPostcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
    const $shippingEstimatorZip = $('.ShippingEstimator__Zip');
    if (!isPostcodeAutoSet && chosenPostcode) {
      $shippingEstimatorZip.val(chosenPostcode);
      $shippingEstimatorZip.get(0).dispatchEvent(new Event('change'));
    }
  },
  setDeliveryDateText: function (dateAU) {
    // If no date is selected or if dateAU resolves to the default 01/01/1970, show a clickable "select date" link.
    if (!dateAU || dateAU === "01/01/1970") {
      $('[data-delivery-date-text]').html(
        window.themeVariables.strings.cartDeliveryDate + ' <a href="#" id="select-date-link">select date</a>'
      );
      $('[data-delivery-date-text-alt]').html(' <a href="#" id="select-date-link">select date</a>');
      $('#select-date-link').on('click', function(e) {
        e.preventDefault();
        document.getElementById('datepicker-modal').open = true;
      });
    } else {
      $('[data-delivery-date-text]').html(window.themeVariables.strings.cartDeliveryDate).find('b').text(dateAU);
      $('[data-delivery-date-text-alt]').html(dateAU);
    }
  },
  clearCart: async function () {
    await fetch(`${window.themeVariables.routes.cartUrl}/clear.js`, {
      credentials: "same-origin",
      method: "POST",
      headers: { "Content-Type": "application/json" }
    });
  },
  hasPreorderItems: function (cartData) {
    return cartData.items.some(item => item?.tags.filter(tag => tag.includes('preorder')).length > 0);
  },
  resetCartAttributes: async function () {
    await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
      body: JSON.stringify({
        attributes: {
          _delivery__date: null,
          _delivery__day_of_week: null,
          _delivery__postcode: null,
          _order__time_string: null,
        }
      }),
      credentials: "same-origin",
      method: "POST",
      headers: { "Content-Type": "application/json" }
    });
  },
  resetCartDeliveryDate: async function () {
    await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
      body: JSON.stringify({
        attributes: {
          _delivery__date: null,
          _delivery__time_slot: null,
        }
      }),
      credentials: "same-origin",
      method: "POST",
      headers: { "Content-Type": "application/json" }
    });
  }
};

Floral.product = {
  init: function () {
    if ($('body').hasClass('template-product') && $('[data-delivery-variant-unavailable]').length) {
      Floral.utils.initDeliveryVariant();
      Floral.utils.initPricingVariant();
      document.addEventListener('variant:changed', function (event) {
        Floral.utils.initInfiniteOptions();
        Floral.utils.disableVariantsWhenRegionOutOfStock();
        Floral.utils.initPricingVariant();
      });
      $(window).on('load', function () {
        setTimeout(Floral.utils.disableVariantsWhenRegionOutOfStock, 500);
        setTimeout(Floral.utils.initInfiniteOptions, 500);
        // Existing Add to Cart click handler
        const element = document.querySelector('button#AddToCart');
        if (element) {
          element.addEventListener('click', function () {
            element.setAttribute("aria-busy", "true");
            const originalAlert = window.alert;
            let alertShown = false;
            window.alert = function (message) {
              alertShown = true;
              originalAlert(message);
            };
            const interval = setInterval(function () {
              if (alertShown) {
                element.removeAttribute("aria-busy");
                clearInterval(interval);
              }
            }, 1000);
            setTimeout(function () {
              clearInterval(interval);
              window.alert = originalAlert;
            }, 5000);
          }, {capture: true});
        }
      });
    }
  },
  updateRelatedProductsModal: function () {
    const excludeProduct = (null !== window.themeVariables.constants.productId ? ` AND -id:${window.themeVariables.constants.productId}` : '');
    fetch(`/search?view=related-products&type=product&q=\*${excludeProduct}&filter.v.availability=1&filter.v.option.delivery=${Floral.utils.getChosenPostcodeData()}`, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      response.text().then(function (content) {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content;
        document.querySelector('#related-products-modal .related-products__wrapper').innerHTML = tempElement.querySelector('.ProductListWrapper').innerHTML;
      });
    });
  },
};

Floral.collection = {
  init: function () {
    if ($('body').hasClass('template-collection')) {
      const {constants, deliveryRegionSlugMappings, strings} = window.themeVariables;
      const expectedDeliveryRegionName = Floral.utils.getChosenPostcodeData();
      const chosenPostcode = Floral.cookie.get(constants.cookieNamePostcode);
      const chosenState = Floral.cookie.get(constants.cookieNameState);
      const isPostcodeAutoSet = !!Floral.cookie.get(constants.cookieNamePostcodeAutoSet);
      const hasDeliveryParam = new URLSearchParams(location.search).has('filter.v.option.delivery');
      
      $(document).on('postcode_updated.floral', function () {
        Floral.collection.reloadProductsWithDelivery();
      });

      // Run immediately on load (DOM-only filter, no navigation)
      try {
        Floral.collection.filterProductsByDate();
      } catch (e) { console.warn('Date Filter Error', e); }

      $(document).on('theme:loading:end', function () {
        window.Floral.utils.updateSameDayTags();
      });
      if (expectedDeliveryRegionName && !hasDeliveryParam) {
        Floral.collection.reloadProductsWithDelivery(true);
      }
      const lastSegment = Floral.utils.getPathNameLastSegment();
      if (lastSegment.toLowerCase() in deliveryRegionSlugMappings) {
        if ((!chosenPostcode || isPostcodeAutoSet) && !hasDeliveryParam) {
          $(window).on('load', function () {
            const sampleRegion = deliveryRegionSlugMappings[lastSegment.toLowerCase()];
            Floral.utils.initSampleRegion(sampleRegion, true);
          });
        } else {
          if (Floral.utils.getStateFromRegion(deliveryRegionSlugMappings[lastSegment.toLowerCase()]) !== chosenState) {
            Floral.collection.showPostcodeModalOnScroll(strings.postcodeSelectorHeadingChangeState);
          }
        }
      } else if (!chosenPostcode) {
        Floral.collection.showPostcodeModalOnScroll();
      }
    }
  },

  // DOM-only: hide/show products by tag on peak dates
  filterProductsByDate: function() {
    if (!window.themeVariables || !window.themeVariables.constants) return;
    
    const dateISO = sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);
    const isPeak = (dateISO && Floral.utils && Floral.utils.isPeakDate) ? Floral.utils.isPeakDate(dateISO) : false;
    const REQUIRED_TAGS = ['valentines', 'mothers-day'];

    $('.product-item').each(function() {
      const $product = $(this);
      const productTags = String($product.data('tags') || '');

      if (isPeak) {
        const hasRequiredTag = REQUIRED_TAGS.some(tag => productTags.includes(tag));

        if (hasRequiredTag) {
          $product.removeClass('hidden-by-delivery-logic').show();
        } else {
          $product.addClass('hidden-by-delivery-logic').hide();
        }
      } else {
        $product.removeClass('hidden-by-delivery-logic').show();
      }
    });
  },

  reloadProductsWithDelivery: function (firstLoad = false) {
    const region = Floral.utils.getChosenPostcodeData();
    if (region) {
      const $deliveryFilters = $('#facet-filter-filter\\.v\\.option\\.delivery');
      const $availabilityFilters = $('#facet-filter-filter\\.v\\.availability');
      $deliveryFilters.find('input[type="checkbox"]').prop('checked', false);
      $availabilityFilters.find('input[type="checkbox"]').prop('checked', false);
      $availabilityFilters.find(`input[name="filter.v.availability"][value="1"]`).prop('checked', true);
      $deliveryFilters.find(`input[type="checkbox"][value="${region}"]`).prop('checked', false).click();
      $('body').data('delivery-first-load', firstLoad);
    }
  },
  showPostcodeModalOnScroll: function (customHeading = null) {
    const throttle = 100;
    let scrollTimeout;
    let modalPopped = false;
    $(window).on('scroll', function () {
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(function () {
          if (!modalPopped && $(window).scrollTop() > 700) {
            Floral.utils.openPostcodeModal(customHeading);
            modalPopped = true;
          }
          scrollTimeout = null;
        }, throttle);
      }
    });
  },
  getUpsellProducts: async function () {
    const upsellProducts = window.themeVariables.upsellProductVariants;
    if (upsellProducts?.length) {
      return upsellProducts;
    }
    const cachedData = localStorage.getItem('upsellProductVariants');
    if (cachedData) {
      try {
        const { variants, timestamp } = JSON.parse(cachedData);
        if (Date.now() - timestamp < 3600000) {
          window.themeVariables.upsellProductVariants = variants;
          return variants;
        }
        localStorage.removeItem('upsellProductVariants');
      } catch (e) {
        console.warn('Failed to parse cached upsell variants');
        localStorage.removeItem('upsellProductVariants');
      }
    }
    let allProducts = [];
    let page = 1;
    while (true) {
      const response = await fetch(`/collections/upsells/products.json?page=${page}&limit=250`);
      const data = await response.json();
      if (data.products.length === 0) break;
      allProducts = allProducts.concat(data.products);
      page++;
    }
    const variants = allProducts.flatMap(product => 
      product.variants.map(variant => ({
        id: variant.id,
        available: variant.available
      }))
    );
    window.themeVariables.upsellProductVariants = variants;
    localStorage.setItem('upsellProductVariants', JSON.stringify({
      variants,
      timestamp: Date.now()
    }));
    return variants;
  }
};

Floral.cookie = {
  set: function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  get: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
};

Floral.utils = {
  // Helper: safely convert strings to arrays
  ensureArray: function(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') return val.split('\n');
    return [];
  },

  /**
   * Build a collection URL that includes or removes a tag filter using Shopify tag path:
   *   /collections/<handle>/<tag-handle>
   */
  applyTagToCollectionUrl: function (href, tagHandle, shouldApply) {
    if (!href) return href;

    const url = new URL(href, window.location.origin);
    const parts = url.pathname.split('/').filter(Boolean); // ["collections","handle","maybeTag"]

    if (parts[0] !== 'collections' || !parts[1]) return href;

    const collectionHandle = parts[1];
    const currentTag = parts[2] || null;

    if (shouldApply) {
      if (currentTag !== tagHandle) {
        url.pathname = `/collections/${collectionHandle}/${tagHandle}`;
      }
    } else {
      if (currentTag === tagHandle) {
        url.pathname = `/collections/${collectionHandle}`;
      }
    }

    return url.pathname + url.search + url.hash;
  },

  /**
   * Compute the final destination URL for collection links based on the selected date.
   * If peak date => add /valentines. Else remove it (if present).
   */
  getCollectionHrefForSelectedDate: function (href) {
    const dateISO = sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);
    const isPeak = dateISO && Floral.utils.isPeakDate(dateISO);

    const TAG_HANDLE = 'valentines';
    return Floral.utils.applyTagToCollectionUrl(href, TAG_HANDLE, !!isPeak);
  },

  disableVariantsWhenRegionOutOfStock: function () {
    setTimeout(function () {
      const $variantForm = $('.product-form');
      const $infiniteoptions = $('#infiniteoptions-container');

      const expectedDeliveryRegionName = Floral.utils.getChosenPostcodeData();
      const $variantOption = $variantForm.find(`[value="${expectedDeliveryRegionName}"]`);
      const $variantUnavailableOption = $variantForm.find(`[data-delivery-variant-unavailable]`);

      // We "gate" the size selector when delivery isn't set. Track what we disable so we can safely re-enable it
      // without accidentally enabling genuinely out-of-stock options.
      const $allVisibleSwatches = $variantForm.find('.product-form__option-selector:not(.visually-hidden) .variant-swatch');

      const shouldGate =
        ($variantOption.length && $variantOption.closest('.variant-swatch').hasClass('is-disabled')) ||
        $variantUnavailableOption.is(':checked');

      if (shouldGate) {
        $allVisibleSwatches.addClass('is-disabled delivery-locked');
        $infiniteoptions.hide();
      } else {
        $allVisibleSwatches.filter('.delivery-locked').removeClass('is-disabled delivery-locked');
        $infiniteoptions.show();
        $(document).trigger({ type: 'infinite_options_ready.floral' });
      }
    }, 100);
  },

  autoSelectRequiredInfiniteOptions: function () {
    const requiredVariantsGroups = $('#infiniteoptions-container [data-required="true"], #infiniteoptions-container [data-required-original="true"]');
    if (requiredVariantsGroups.length) {
      requiredVariantsGroups.attr('data-required-original', 'true');
      requiredVariantsGroups.each(function () {
        const $self = $(this);
        $self.removeAttr('data-required');
        const requiredVariant = $self.find('label.spb-productoptionswatchwrapper');
        if (requiredVariant.length && requiredVariant.find('input:checked').length) {
          requiredVariant.each(function () {
            $(this).click();
          });
        }
        if (requiredVariant.is(':visible')) {
          requiredVariant.each(function () {
            $(this).click();
          });
        }
      });
    }
  },

  initInfiniteOptions: async function () {
    if (
      $('#infiniteoptions-container').children().length &&
      window.Shoppad &&
      window.Shoppad.apps &&
      window.Shoppad.apps.infiniteoptions
    ) {
      Floral.utils.renameGiftProperty();
      const {priceMod: {variantOrdering}} = window.Shoppad.apps.infiniteoptions;
      if (variantOrdering.length) {
        const upsellProductVariants = await Floral.collection.getUpsellProducts();
        const outOfStockVariants = upsellProductVariants.filter(variant => !variant.available);
        $('label.spb-productoptionswatchwrapper').each(function (index) {
          const $self = $(this);
          const variantValue = variantOrdering[index];
          const isOutOfStock = outOfStockVariants.some(variant => variantValue.includes(variant.id));
          $self.addClass(`variant--${variantValue}`);
          if (isOutOfStock) {
            $self.addClass('variant--out-of-stock');
            $self.hide();
          }
        });
        $('[id^="infOption"]').each(function () {
          const $self = $(this);
          const variantGroups = $self.find('label.spb-productoptionswatchwrapper');
          const variantOutOfStock = $self.find('label.spb-productoptionswatchwrapper.variant--out-of-stock');
          if (variantGroups.length === variantOutOfStock.length) {
            $self.hide();
          }
        });
      }
      $(document).off('infinite_options_ready.floral').on('infinite_options_ready.floral', function (e) {
        Floral.utils.autoSelectRequiredInfiniteOptions();
      });
    }
  },

  initAutoComplete: function () {
    const $postcodeSelectorForm = $('#postcode-selector-form');
    const $postcodeSelectorInputs = $('[data-delivery-postcode-autocomplete]');
    $postcodeSelectorInputs.each(function () {
      const $this = $(this);
      $this.easyAutocomplete({
        url: window.themeVariables.libs.autocomplete,
        getValue: function (place) {
          return `${place.place_name}, ${place.state_code} ${place.postcode}`;
        },
        list: {
          match: { enabled: true },
          onChooseEvent: function (e) {
            const place = $this.getSelectedItemData();
            $postcodeSelectorForm.get(0).dataset.postcode = place.postcode;
            $postcodeSelectorForm.get(0).dataset.suburb = place.place_name;
            $postcodeSelectorForm.get(0).dataset.state = place.state_code;
            $postcodeSelectorForm.get(0).dataset.autoSet = '';
            $postcodeSelectorForm.trigger('submit');
          }
        },
      });
    });
  },

  initDeliveryLogics: async function () {
    const {
      cookieNamePostcode,
      cookieNameSuburb,
      cookieNameState,
      cookieNamePostcodeAutoSet,
      cookieExpiration
    } = window.themeVariables.constants;

    const cookiePostcode = Floral.cookie.get(cookieNamePostcode);
    const cookieSuburb = Floral.cookie.get(cookieNameSuburb);
    const cookieState = Floral.cookie.get(cookieNameState);
    const cookiePostcodeAutoSet = Floral.cookie.get(cookieNamePostcodeAutoSet);

    if (cookiePostcode && cookieState) {
      Floral.cookie.set(cookieNamePostcode, cookiePostcode, cookieExpiration);
      Floral.cookie.set(cookieNameSuburb, cookieSuburb, cookieExpiration);
      Floral.cookie.set(cookieNameState, cookieState, cookieExpiration);
      Floral.cookie.set(cookieNamePostcodeAutoSet, cookiePostcodeAutoSet, cookieExpiration);

      $('a[href*="/collections/"]').each(function () {
        const $this = $(this);
        const lastSegment = Floral.utils.getPathNameLastSegment($this.attr('href'));
        if (
          !(lastSegment.toLowerCase() in window.themeVariables.deliveryRegionSlugMappings) &&
          '#' !== $this.attr('href') &&
          !$(this).attr('href').includes('/products/')
        ) {
          const url = new URL($this.attr('href'), location.protocol + '//' + location.host);
          url.searchParams.set('filter.v.availability', '1');
          url.searchParams.set('filter.v.option.delivery', Floral.utils.getChosenPostcodeData());
          $this.attr('href', url.href);
        }
      });
    } else {
      void Floral.cart.clearCart();
    }
  },

  initDeliveryVariant: function (params = {showRelatedProductModal: false}) {
    const isPostcodeAutoSet = !!Floral.cookie.get(window.themeVariables.constants.cookieNamePostcodeAutoSet);
    const expectedDeliveryRegionName = Floral.utils.getChosenPostcodeData();
    const $variantForm = $('.product-form');
    const $hiddenOnPostcodeFound = $('[data-delivery-hidden-when="postcodeSelected"]');
    const $hiddenOnPostcodeNotFound = $('[data-delivery-hidden-when="postcodeNotSelected"]');

    if (!isPostcodeAutoSet && expectedDeliveryRegionName) {
      $hiddenOnPostcodeFound.hide();
      $hiddenOnPostcodeNotFound.show();
    } else {
      $hiddenOnPostcodeFound.show();
      $hiddenOnPostcodeNotFound.hide();
    }

    $variantForm.each(function () {
      const $self = $(this);
      const $variantUnavailableOption = $self.find(`[data-delivery-variant-unavailable]`);
      const $variantOption = $self.find(`[value="${expectedDeliveryRegionName}"]`);
      const $hiddenOnVariantAvailable = $self.find(`[data-delivery-hidden-when="variantAvailable"]`);
      const $hiddenOnVariantNotAvailable = $self.find(`[data-delivery-hidden-when="variantNotAvailable"]`);

      if (!isPostcodeAutoSet && expectedDeliveryRegionName) {
        if ($variantOption.length) {
          setTimeout(function () {
            // Make sure the "unavailable" radio is not left selected (that would keep everything gated/greyed-out)
            $variantUnavailableOption.each(function () {
              $(this).prop('checked', false).trigger('change');
            });

            // Select the correct delivery region option so the theme re-evaluates availability
            $variantOption.prop('checked', false).click();

            // Re-run gating logic shortly after the theme reacts
            setTimeout(function () {
              Floral.utils.disableVariantsWhenRegionOutOfStock();
            }, 150);
          }, 500);

          $hiddenOnVariantAvailable.hide();
          $hiddenOnVariantNotAvailable.show();
          return true;
        }
      }

      const hasVariantParam = new URLSearchParams(location.search).has('variant');
      if (hasVariantParam && !expectedDeliveryRegionName) {
        const $checkedVariantOption = $variantUnavailableOption.closest('.variant-swatch-list').find(`[type="radio"]:checked`);
        const regionName = $checkedVariantOption.val();
        Floral.utils.initSampleRegion(regionName);
        return true;
      }

      setTimeout(function () {
        $variantUnavailableOption.each(function () {
          $(this).prop('checked', false).click();
        });
      }, 500);

      Floral.product.updateRelatedProductsModal();
      $hiddenOnVariantAvailable.show();
      $hiddenOnVariantNotAvailable.hide();
    });

    return false;
  },

  initPricingVariant: function (params = {dateISO: null}) {
    const {dateISO} = params;
    const selectedDateISO = dateISO ? dateISO : sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);

    const isPeak = selectedDateISO ? Floral.utils.isPeakDate(selectedDateISO) : false;
    const $variantForm = $('.product-form');

    $variantForm.each(function () {
      const $self = $(this);

      const variantPeak = $self.find(`[value="Peak"]`).get(0);
      const variantRegular = $self.find(`[value="Regular"]`).get(0);

      setTimeout(function () {
        const targetVariant = isPeak ? variantPeak : variantRegular;

        if (targetVariant) {
          targetVariant.checked = true;

          const clickEvent = new MouseEvent('click', {
             view: window,
             bubbles: true,
             cancelable: true
          });
          targetVariant.dispatchEvent(clickEvent);
          targetVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 750);
    });

    return false;
  },

  initSampleRegion: function (sampleRegion, autoSet = false) {
    const $postcodeSelectorForm = $('#postcode-selector-form');
    if (sampleRegion in window.themeVariables['deliveryPostcodeSamples']) {
      $postcodeSelectorForm.get(0).dataset.postcode = window.themeVariables['deliveryPostcodeSamples'][sampleRegion];
      $postcodeSelectorForm.get(0).dataset.suburb = '';
      $postcodeSelectorForm.get(0).dataset.autoSet = autoSet ? sampleRegion : '';
      $postcodeSelectorForm.get(0).dataset.state = Floral.utils.getStateFromRegion(sampleRegion);

      $postcodeSelectorForm.get(0).reset();
      $postcodeSelectorForm.trigger('submit');
    }
  },

  initTimeSlots: async function ({selectedDateAU, selectedTimeslot}) {
    const $allWrappers = $("[data-delivery-quick-time-wrapper]");
    const chosenPostcodeTimeSlots = Floral.utils.getChosenPostcodeData('timeSlots');
    const chosenPostcodeBlockedDays = Floral.utils.getChosenPostcodeBlockedDays();

    const selectedDateObj = selectedDateAU ? new Date(selectedDateAU.split('/').reverse().join('/')) : null;
    const chosenStateSelectedDayTime = selectedDateObj ? Floral.utils.getChosenStateCurrentDateTime(selectedDateObj) : null;
    const chosenPostcodeWeekday = chosenStateSelectedDayTime?.weekday;
    const chosenPostcodeSpecificDate = chosenPostcodeTimeSlots?.[$.datepicker.formatDate('yy/mm/dd', selectedDateObj)];

    if (
      !Floral.utils.isDateAvailable(selectedDateObj, chosenPostcodeBlockedDays) ||
      !chosenPostcodeTimeSlots ||
      !chosenPostcodeWeekday ||
      (chosenPostcodeSpecificDate && (`${chosenPostcodeSpecificDate}` === '0')) ||
      !chosenPostcodeTimeSlots?.[chosenPostcodeWeekday] ||
      `${chosenPostcodeTimeSlots?.[chosenPostcodeWeekday].trim()}` === '0'
    ) {
      $allWrappers.slideUp();
      Floral.cart.changeCartLineItemsAtts(selectedDateAU, null);
      return;
    } else {
      Floral.cart.changeCartLineItemsAtts(selectedDateAU, selectedTimeslot);
    }

    const slotsString = chosenPostcodeSpecificDate ? chosenPostcodeSpecificDate : chosenPostcodeTimeSlots?.[chosenPostcodeWeekday];
    const buttonsArr = slotsString.split(',').map(timeSlot => {
      if (!timeSlot.trim()) {
        return '';
      }
      const currentTime = chosenStateSelectedDayTime.hour;
      const timeSlotArr = timeSlot.split('-');
      if (timeSlotArr.length !== 2) {
        return '';
      }
      const timeSlotStart = timeSlotArr[0];
      const timeSlotEnd = timeSlotArr[1];
      const timeSlotStartStr = Floral.utils.getConvertedHour(timeSlotStart);
      const timeSlotEndStr = Floral.utils.getConvertedHour(timeSlotEnd);
      const timeSlotStr = `${timeSlotStartStr} - ${timeSlotEndStr}`;
      if (currentTime >= timeSlotStart) {
        return '';
      }
      return `<button type="button" data-delivery-quick-time="${timeSlot}" style="margin-right: 5px;margin-bottom: 5px;" class="button button--outline button--small ${selectedTimeslot && selectedTimeslot === timeSlot ? 'active' : ''}">${timeSlotStr}</button>`;
    });
    const buttonsHtml = buttonsArr.filter(html => html).join('');
    $allWrappers.each(function () {
      const $wrapper = $(this);
      if (buttonsHtml) {
        $wrapper.find('button').remove();
        $wrapper.append(buttonsHtml);
        $wrapper.append(`<button type="button" data-delivery-quick-time="" style="margin-right: 5px;margin-bottom: 5px;" class="button button--outline button--small ${!selectedTimeslot ? 'active' : ''}">No, thanks</button>`);
        $wrapper.slideDown(400);
      } else {
        $wrapper.slideUp(400, function () {
          $wrapper.find('button').remove();
        });
      }
    });
    $(document).off('click', '[data-delivery-quick-time]').on('click', '[data-delivery-quick-time]', function () {
      const self = $(this);
      if (self.hasClass('active')) {
        return false;
      }
      const timeRange = self.data('delivery-quick-time');
      $('.cart__delivery-quick-select--time button').removeClass('active');
      self.addClass('active');
      $(document).trigger({
        type: 'time_updated.floral',
        timeRange
      });
    });
    $(document).off('time_updated.floral').on('time_updated.floral', async function (e) {
      await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
        body: JSON.stringify({
          attributes: {
            _delivery__time_slot: e?.timeRange,
          }
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
      Floral.cart.changeCartLineItemsAtts(null, e?.timeRange);
    });
  },

  initDatePickers: async function () {
    const $datePicker = $("[data-delivery-date-picker]");
    if ($datePicker.length) {
      if ($datePicker.hasClass('hasDatepicker')) {
        $datePicker.datepicker('destroy');
      }
      let isAllSameDay = true; 
      let foundSomeQuickDateMatch = false;
      let minAvailableDate = '2D';
      const state = Floral.cookie.get(window.themeVariables.constants.cookieNameState);

      let cartData = null;
      try {
        const response = await fetch(`${window.themeVariables.routes.cartUrl}?view=line-items-info`);
        cartData = await response.json();
      } catch (error) {
        console.warn('Cart data fetch failed in Date Picker init - assuming empty cart logic', error);
      }

      const chosenStateCurrentDayTime = Floral.utils.getChosenStateCurrentDateTime();
      const chosenPostcodeBlockedDays = Floral.utils.getChosenPostcodeBlockedDays(cartData);
      const selectedDeliveryDateAU = cartData?.attributes?.['_delivery__date'];

      if (state) {
        if (cartData?.items && cartData.items.length > 0) {
           isAllSameDay = cartData.items.every(item => {
             const sameDayTags = item?.tags.filter(tag => tag.includes('same day'));
             const sameDayStates = sameDayTags?.map(tag => tag.split('same day ')[1].toLowerCase());
             return sameDayStates?.includes(state.toLowerCase());
           });
        }

        minAvailableDate = Floral.utils.getMinAvailableDate(isAllSameDay);
        const minAvailableDateInt = parseInt(minAvailableDate);
        if (minAvailableDateInt > 0) {
          for (let i = 0; i < minAvailableDateInt; i++) {
            const dateObj = new Date(chosenStateCurrentDayTime.dateISO);
            dateObj.setDate(dateObj.getDate() + i);
            chosenPostcodeBlockedDays.blockedFullDays.push($.datepicker.formatDate('yy/mm/dd', dateObj));
          }
        }
      }

      $('[data-delivery-quick-date]').hide().each(function () {
        let dateObj;
        const self = $(this);
        const targetDateISO = self.data('delivery-quick-date');
        switch (targetDateISO) {
          case 'today':
            dateObj = new Date(chosenStateCurrentDayTime.dateISO);
            break;
          case 'tomorrow':
            dateObj = new Date(chosenStateCurrentDayTime.dateISO);
            dateObj.setDate(dateObj.getDate() + 1);
            break;
          default:
            dateObj = new Date(targetDateISO);
        }
        if (selectedDeliveryDateAU === $.datepicker.formatDate('dd/mm/yy', dateObj)) {
          self.addClass('active');
          foundSomeQuickDateMatch = true;
        }
        const dateISO = $.datepicker.formatDate('yy/mm/dd', dateObj);
        self.data('delivery-quick-date', dateISO);
        self.attr('data-delivery-quick-date', dateISO);
        if (Floral.utils.isDateAvailable(dateObj, chosenPostcodeBlockedDays)) {
          self.show();
        }
      });

      const selectedDateNotForDelivery =
        selectedDeliveryDateAU &&
        !Floral.utils.isDateAvailable(new Date(selectedDeliveryDateAU.split('/').reverse().join('/')), chosenPostcodeBlockedDays);

      if (selectedDateNotForDelivery) {
        Floral.cart.setDeliveryDateText('');
        await Floral.cart.resetCartDeliveryDate();
        document.getElementById('mini-cart-note').open = true;
        sessionStorage.removeItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);
        Floral.utils.initPricingVariant();
      } else if (selectedDeliveryDateAU) {
        const dateISO = selectedDeliveryDateAU.split('/').reverse().join('/');
        sessionStorage.setItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO, dateISO);
        Floral.utils.initPricingVariant({dateISO});
      }

      $(document).off('click', '[data-delivery-quick-date]').on('click', '[data-delivery-quick-date]', function () {
        const self = $(this);
        if (self.hasClass('active')) {
          return false;
        }
        const dateObj = new Date(self.data('delivery-quick-date'));
        if (dateObj && Floral.utils.isDateAvailable(dateObj, chosenPostcodeBlockedDays)) {
          const dateISO = $.datepicker.formatDate('yy/mm/dd', dateObj);
          $datePicker.datepicker('setDate', dateISO);
          $('.cart__delivery-quick-select button').removeClass('active');
          self.addClass('active');

          // Trigger WITHOUT namespace so all namespaced handlers receive it
          $(document).trigger({
            type: 'date_updated',
            dateISO
          });
        }
      });

      // Date picker handler (namespaced), will still run when 'date_updated' is triggered
      $(document)
        .off('date_updated.floralDatePicker')
        .on('date_updated.floralDatePicker', async function (e) {
          if (e?.dateISO) {
            sessionStorage.setItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO, e.dateISO);
            Floral.utils.initPricingVariant({dateISO: e.dateISO});
            document.getElementById('datepicker-modal').open = false;

            const dateAU = $.datepicker.formatDate('dd/mm/yy', new Date(e.dateISO));
            Floral.cart.setDeliveryDateText(dateAU);

            await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
              body: JSON.stringify({
                attributes: {
                  _delivery__date: dateAU,
                  _delivery__time_slot: null,
                }
              }),
              credentials: "same-origin",
              method: "POST",
              headers: { "Content-Type": "application/json" }
            });

            void Floral.utils.initTimeSlots({
              selectedDateAU: dateAU,
              selectedTimeslot: null,
            });
          }
        });

      void Floral.utils.initTimeSlots({
        selectedDateAU: selectedDateNotForDelivery ? null : selectedDeliveryDateAU,
        selectedTimeslot: cartData?.attributes?.['_delivery__time_slot'],
      });

      $datePicker.datepicker({
        dateFormat: "yy/mm/dd",
        buttonText: selectedDeliveryDateAU ? selectedDeliveryDateAU : "Select Date",
        minDate: '0D',
        maxDate: "+6M",
        showOn: "both",
        firstDay: 1,
        showButtonPanel: false,
        beforeShowDay: function (dateObj) {
          const enable = Floral.utils.isDateAvailable(dateObj, chosenPostcodeBlockedDays);
          return [enable, enable ? 'day-enabled' : 'day-blocked', ''];
        },
        onSelect: async function (dateISO) {
          $('.cart__delivery-quick-select button').removeClass('active');
          $('.ui-datepicker-trigger').addClass('active');

          // Trigger WITHOUT namespace so all namespaced handlers receive it
          $(document).trigger({
            type: 'date_updated',
            dateISO
          });
        }
      });

      const $datePickerTrigger = $datePicker.next(".ui-datepicker-trigger");
      $datePickerTrigger.addClass("button button--outline button--small");
      $datePickerTrigger.addClass((!foundSomeQuickDateMatch && selectedDeliveryDateAU) ? 'active' : '');
      $datePickerTrigger.attr('data-delivery-date-text-alt', '');
    }
  },

  updateSuburbText: function (selector, suburbOnly = false) {
    if ($(selector).length) {
      const postcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
      const suburb = Floral.cookie.get(window.themeVariables.constants.cookieNameSuburb);
      const state = Floral.cookie.get(window.themeVariables.constants.cookieNameState);
      if (postcode) {
        if (suburb) {
          suburbOnly ? $(selector).text(`${suburb}`) : $(selector).text(`${suburb}, ${state} ${postcode}`);
        } else {
          $(selector).text(`${state} ${postcode}`);
        }
      } else {
        $(selector).text('');
      }
    }
  },

  updateAllTextRelatedToDate: function () {
    const dateISO = sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);
    const dateAU = $.datepicker.formatDate('dd/mm/yy', new Date(dateISO));
    if (dateAU) {
      Floral.cart.setDeliveryDateText(dateAU);
    }
  },

  updateAllTextRelatedToDelivery: function (firstLoad = false) {
    const $body = $('body');
    const $shortDeliveryText = $('.PostcodeSelector__ShortDeliveryText');
    if ($shortDeliveryText.length) {
      const $shortDeliveryTextWrapper = $('.PostcodeSelector__ShortDeliveryText__Wrapper');
      const postcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
      const state = Floral.cookie.get(window.themeVariables.constants.cookieNameState);
      const animateStyle = 'animate__swing animate__animated';
      if (postcode) {
        $shortDeliveryTextWrapper.fadeIn();
        $shortDeliveryText.text(`${state} ${postcode}`);
        if (!firstLoad) {
          setTimeout(function () {
            $shortDeliveryText.addClass(animateStyle);
          }, 500);
          setTimeout(function () {
            $shortDeliveryText.removeClass(animateStyle);
          }, 2000);
        }
      } else {
        $shortDeliveryTextWrapper.hide();
      }
    }
    window.Floral.utils.updateSuburbText('.PostcodeSelector__FullDeliveryText');
    window.Floral.utils.updateSuburbText('.PostcodeSelector__SuburbDeliverText', true);
    if (firstLoad || !$body.hasClass('template-collection')) {
      window.Floral.utils.updateSameDayTags();
    }
    const region = Floral.utils.getChosenPostcodeData();
    if (region) {
      $body.removeClass(function (index, className) {
        return (className.match(/(^|\s)delivery-selected-region--\S+/g) || []).join(' ');
      });
      $body.addClass(`delivery-selected-region--${region.toLowerCase().trim().replace(' ', '-')}`);
    }
  },

  updateSameDayTags: function () {
    const $sameDayLabels = $("[data-delivery-same-day-label]");
    if (!$sameDayLabels.length) {
      return;
    }
    const {constants} = window.themeVariables;
    const state = Floral.cookie.get(constants.cookieNameState);
    const chosenStateCurrentDayTime = Floral.utils.getChosenStateCurrentDateTime();
    const chosenPostcodeSameDayCutoffHour = Floral.utils.getChosenPostcodeSameDayCutOffHour();
    $sameDayLabels.hide();
    if (state) {
      $sameDayLabels.each(function () {
        const $self = $(this);
        if ($self.data('delivery-same-day-label').includes(state.toLowerCase())) {
          $self.find('[data-delivery-same-day-cutoff-label]').text(`, Until ${Floral.utils.getConvertedHour(chosenPostcodeSameDayCutoffHour)}`);
          $self.show();
        }
      });
    }
  },

  getStateFromRegion: function (region) {
    return region
      .replace('Perth Metro', 'WA')
      .replace('Sydney Metro', 'NSW')
      .replace('Brisbane Metro', 'QLD')
      .replace('Adelaide Metro', 'SA')
      .replace('Melbourne Metro', 'VIC');
  },

  getPathNameLastSegment: function (pathname = null) {
    const parts = pathname ? pathname.split('/') : location.pathname.split('/');
    return parts.pop() || parts.pop();
  },

  getChosenStateCurrentDateTime: function (currentTime = new Date()) {
    const state = Floral.cookie.get(window.themeVariables.constants.cookieNameState);
    let timeZone;
    switch (state.toLowerCase()) {
      case 'wa':
        timeZone = "Australia/Perth";
        break;
      case 'qld':
        timeZone = "Australia/Brisbane";
        break;
      case 'nt':
        timeZone = "Australia/Darwin";
        break;
      case 'sa':
        timeZone = "Australia/Adelaide";
        break;
      default:
        timeZone = "Australia/Sydney";
    }
    const dateAU = currentTime.toLocaleString("en-AU", {
      timeZone: timeZone,
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    });
    return {
      weekday: currentTime.toLocaleString("en-AU", {
        timeZone: timeZone,
        weekday: 'long'
      }).toLowerCase(),
      hour: parseInt(currentTime.toLocaleString("en-AU", {
        timeZone: timeZone,
        hour12: false,
        hour: 'numeric'
      })),
      day: parseInt(dateAU.split('/')[0]),
      month: parseInt(dateAU.split('/')[1]),
      year: parseInt(dateAU.split('/')[2]),
      date: dateAU,
      dateISO: dateAU.split('/').reverse().join('/')
    };
  },

  getChosenPostcodeData: function (key = 'optionName') {
    const chosenPostcode = Floral.cookie.get(window.themeVariables.constants.cookieNamePostcode);
    const deliveryPostcodes = window.themeVariables?.deliveryPostcodes || [];
    if (chosenPostcode && deliveryPostcodes.length) {
      for (let i = 0; i < deliveryPostcodes.length; i++) {
        const postcodes = deliveryPostcodes[i]['postcodes']
        if (postcodes && postcodes.length) {
          for (let j = 0; j < postcodes.length; j++) {
            if (postcodes[j].includes('-')) {
              const range = postcodes[j].split('-');
              if (
                !isNaN(range[0]) &&
                !isNaN(range[1]) &&
                parseInt(range[0]) <= parseInt(chosenPostcode) &&
                parseInt(chosenPostcode) <= parseInt(range[1])
              ) {
                return deliveryPostcodes[i][key]
              }
            } else if (
              !isNaN(postcodes[j]) &&
              parseInt(chosenPostcode) === parseInt(postcodes[j])
            ) {
              return deliveryPostcodes[i][key]
            }
          }
        }
      }
    }
    return false;
  },

  getChosenPostcodeSameDayCutOffHour: function () {
    const chosenStateCurrentDayTime = Floral.utils.getChosenStateCurrentDateTime();
    const chosenPostcodeSameDayCutoff = Floral.utils.getChosenPostcodeData('sameDayCutoff');
    const isoDate = chosenStateCurrentDayTime.dateISO;
    let sameDayCutoffHour;
    if (chosenPostcodeSameDayCutoff?.[isoDate]) {
      sameDayCutoffHour = chosenPostcodeSameDayCutoff[isoDate];
    } else {
      sameDayCutoffHour = chosenPostcodeSameDayCutoff?.[chosenStateCurrentDayTime.weekday];
    }
    return sameDayCutoffHour;
  },

  getChosenPostcodeNextDayCutOffHour: function () {
    const chosenStateCurrentDayTime = Floral.utils.getChosenStateCurrentDateTime();
    const chosenPostcodeNextDayCutoff = Floral.utils.getChosenPostcodeData('nextDayCutoff');
    const isoDate = chosenStateCurrentDayTime.dateISO;
    let nextDayCutoffHour;
    if (chosenPostcodeNextDayCutoff?.[isoDate]) {
      nextDayCutoffHour = chosenPostcodeNextDayCutoff[isoDate];
    } else {
      nextDayCutoffHour = chosenPostcodeNextDayCutoff?.[chosenStateCurrentDayTime.weekday];
    }
    return nextDayCutoffHour;
  },

  getChosenPostcodeBlockedDays: function (cartData = null) {
    const {deliveryBlockedDatesNational} = window.themeVariables;

    function ensureArray(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      if (typeof val === 'string') return val.split('\n');
      return [];
    }

    const chosenStateBlockedDays = ensureArray(Floral.utils.getChosenPostcodeData('blockedDays'));
    const chosenStateBlockedDaysPreorder = (cartData && Floral.cart.hasPreorderItems(cartData)) ? ensureArray(Floral.utils.getChosenPostcodeData('blockedDaysPreorder')) : [];
    const nationalBlocked = ensureArray(deliveryBlockedDatesNational);

    const allBlockedDays = [
      ...chosenStateBlockedDaysPreorder,
      ...chosenStateBlockedDays,
      ...nationalBlocked,
    ];

    const mappedWeekDays = {sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6};

    const blockedWeekDayIndex = allBlockedDays.filter(function (day) {
      return day.split('/').length === 1;
    }).map(function (day) {
      return mappedWeekDays[day.trim().toLowerCase()];
    });

    const blockedShortDays = allBlockedDays.filter(function (day) {
      return day.split('/').length === 2;
    }).map(function (day) {
      const currentYear = new Date().getFullYear();
      return `${currentYear}/${day.trim()}`;
    });

    const blockedShortDaysNextYear = allBlockedDays.filter(function (day) {
      return day.split('/').length === 2;
    }).map(function (day) {
      return `${new Date().getFullYear() + 1}/${day.trim()}`;
    });

    const blockedFullDays = allBlockedDays.filter(function (day) {
      return day.split('/').length === 3 && day.charAt(0) !== '-';
    });

    const forcedShowDays = allBlockedDays.filter(function (day) {
      return day.split('/').length === 3 && day.charAt(0) === '-';
    }).map(function (day) {
      return day.substring(1).trim();
    });

    return {
      blockedWeekDayIndex,
      blockedShortDays,
      blockedShortDaysNextYear,
      blockedFullDays,
      forcedShowDays,
    }
  },

  getConvertedHour: function (hour) {
    return (hour % 12 || 12) + (hour < 12 ? 'am' : 'pm');
  },

  getMinAvailableDate: function (isAllSameDay = true) {
    const chosenPostcodeHasSameDayDelivery = Floral.utils.isChosenPostcodeHasSameDayDelivery();
    const chosenPostcodeSameDayCutoffHour = Floral.utils.getChosenPostcodeSameDayCutOffHour();
    const chosenPostcodeNextDayCutoffHour = Floral.utils.getChosenPostcodeNextDayCutOffHour();
    const chosenStateCurrentDayTime = Floral.utils.getChosenStateCurrentDateTime();
    let min;
    if (chosenPostcodeHasSameDayDelivery) {
      if (chosenStateCurrentDayTime.hour >= chosenPostcodeSameDayCutoffHour) {
        min = '1D';
      } else {
        if (chosenStateCurrentDayTime.hour < 4) {
          min = '0D';
        } else {
          min = isAllSameDay ? '0D' : '1D';
        }
      }
    } else {
      if (chosenStateCurrentDayTime.hour >= chosenPostcodeNextDayCutoffHour) {
        min = '2D';
      } else {
        min = isAllSameDay ? '1D' : '2D';
      }
    }
    return min;
  },

  /**
   * Postcode submission handler.
   * Closes postcode modal, triggers postcode_updated, then opens datepicker if missing.
   * Also stores any target URL for post-date redirect in window.floralPendingUrl.
   */
  handlePostcodeSubmission: function (e) {
    e.preventDefault();
    const formTarget = $(e.target).data('target');
    const $postcodeSelectorForm = $('#postcode-selector-form');
    if (!$postcodeSelectorForm.get(0).dataset.postcode) {
      return;
    }
    Floral.cookie.set(window.themeVariables.constants.cookieNamePostcode, $postcodeSelectorForm.get(0).dataset.postcode, window.themeVariables.constants.cookieExpiration);
    Floral.cookie.set(window.themeVariables.constants.cookieNameSuburb, $postcodeSelectorForm.get(0).dataset.suburb, window.themeVariables.constants.cookieExpiration);
    Floral.cookie.set(window.themeVariables.constants.cookieNameState, $postcodeSelectorForm.get(0).dataset.state, window.themeVariables.constants.cookieExpiration);
    Floral.cookie.set(window.themeVariables.constants.cookieNamePostcodeAutoSet, $postcodeSelectorForm.get(0).dataset.autoSet, window.themeVariables.constants.cookieExpiration);

    Floral.utils.closePostcodeModal();

    $(document).trigger({
      type: 'postcode_updated.floral',
      firstVisit: e.firstVisit || false,
    });

    const isDateMissing = !sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);

    if (isDateMissing) {
      setTimeout(function() {
        document.getElementById('datepicker-modal').open = true;
      }, 100);
    }

    if (formTarget && formTarget !== "#") {
      window.floralPendingUrl = formTarget;

      if (!isDateMissing) {
        location.href = formTarget;
      }
    }
  },

  isChosenPostcodeHasSameDayDelivery: function () {
    const chosenPostcodeSameDayCutoff = Floral.utils.getChosenPostcodeData('sameDayCutoff');
    if (!chosenPostcodeSameDayCutoff || typeof chosenPostcodeSameDayCutoff !== 'object') {
        return false;
    }
    const sameWeekDayCutoffKeys = Object.keys(chosenPostcodeSameDayCutoff).filter(function (key) {
      return key.split('/').length === 1;
    });
    return sameWeekDayCutoffKeys.length > 0;
  },

  isDateAvailable: function (dateObj, { blockedWeekDayIndex, blockedShortDays, blockedShortDaysNextYear, blockedFullDays, forcedShowDays } = {}) {
    if (!dateObj) {
      return false;
    }
    let enable = true;
    if (blockedWeekDayIndex?.includes(dateObj.getDay())) {
      enable = false;
    }
    if (blockedShortDays?.includes($.datepicker.formatDate('yy/mm/dd', dateObj))) {
      enable = false;
    }
    if (blockedShortDaysNextYear?.includes($.datepicker.formatDate('yy/mm/dd', dateObj))) {
      enable = false;
    }
    if (blockedFullDays?.includes($.datepicker.formatDate('yy/mm/dd', dateObj))) {
      enable = false;
    }
    if (forcedShowDays?.includes($.datepicker.formatDate('yy/mm/dd', dateObj))) {
      enable = true;
    }
    return enable;
  },

  // Update this function to control which dates count as "peak" (valentines-only)
  isPeakDate: function (selectedDate) {
    const PEAK_STRINGS = [
      '2026/05/09',
      '2026/05/10',
      '2026/5/9',
      '2026/5/10'
    ];
    return PEAK_STRINGS.includes(selectedDate);
  },

  renameGiftProperty: function () {
    $('#infiniteoptions-container [name^="properties"][name*="delivery"][type="hidden"]').remove();
    $('[name="properties[Posy Jar]"]').attr('name', 'properties[_Posy Jar]');
    $('[name="properties[Card]"]').attr('name', 'properties[_Card]');
  },

  openPostcodeModal: function (customHeading = null) {
    if (customHeading) {
      document.getElementById('postcode-selector-modal').querySelector('h2.heading').textContent = customHeading;
    }
    document.getElementById('postcode-selector-modal').open = true;
  },

  closePostcodeModal: function () {
    document.getElementById('postcode-selector-modal').open = false;
  },

  formatMoney: function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    var value = '';
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }
    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }
};

window['Floral'] = Floral;

Floral.init();

/**
 * Mini-cart Checkout Guard
 * In the mini-cart, when the user clicks the checkout button (assumed to have name="checkout"),
 * if no valid delivery date is set (or the date is 01/01/1970), prevent checkout and open the datepicker.
 */
$(document).on('click', '[name="checkout"]', function(e) {
  const dateISO = sessionStorage.getItem(window.themeVariables.constants.sessionSelectedDeliveryDateISO);
  if (!dateISO || dateISO === "01/01/1970") {
    e.preventDefault();
    document.getElementById('datepicker-modal').open = true;
  }
});
